import React, {useEffect, useRef, useState} from 'react';
import {styles} from './HeaderViewStyle';
import {Animated, Image, Text, TouchableOpacity, View} from 'react-native';
import MenuItemsView from "./components/menuitems/MenuItemsView";
import {getToken} from "../../../../../Common/Utils/token.utils";
import {useWindowSizeContext} from "../../../../../Common/contexts/WindowSizeContext";

interface HeaderViewProps {

}

export const HeaderView = ({}: HeaderViewProps) => {
    const {width, isMobile} = useWindowSizeContext();
    const [headerFontSize, setHeaderFontSize] = useState<number>(calculateHeaderFontSize());
    const [menuItemStyle, setMenuItemStyle] = useState<any>(getMenuItemStyle());
    const menuHeight = useRef(new Animated.Value(0)).current;

    const isVisible = width >= 800;
    const headerHeight = 95;
    const menuSize = headerHeight * 0.45;

    const [opened, setOpened] = useState<boolean>(false);

    function getMenuItemStyle() {
        return [
            styles.menuItem,
            {
                marginLeft: isMobile ? 0 : 36,
                fontSize: headerFontSize * 0.75
            }
        ];
    }

    function calculateHeaderFontSize() {
        return isMobile ? 18 : 24
    }

    const toggleMenu = () => {
        setOpened(!opened);

        Animated.timing(menuHeight, {
            toValue: opened ? 0 : 300,
            duration: 300,
            useNativeDriver: false,
        }).start();
    };

    useEffect(() => {
        setMenuItemStyle(getMenuItemStyle());
        setHeaderFontSize(calculateHeaderFontSize());
    }, [width, isMobile, getToken]);

    return (
        <View style={isMobile ? styles.headerMobile : styles.header}>
            <View style={[styles.beebondsContainer]}>
                <Image source={require('./assets/logocircle.svg')} style={[styles.beebondsLogoImage]}/>
                {isVisible && <Text style={[styles.title, {fontSize: headerFontSize}]}>BeeBonds</Text>}
            </View>
            <View>
                {isVisible ? (
                    <View style={{padding: 25}}>
                        <View style={styles.menuHorizontal}>
                            <MenuItemsView menuItemStyle={menuItemStyle} isVisible={isVisible}/>
                        </View>
                    </View>
                ) : (
                    <View style={[styles.mobileMenuContainer]}>
                        <TouchableOpacity style={{marginRight: 20}} onPress={toggleMenu}>
                            <Image source={{uri: opened ? require('./assets/exit-cross-black.png') :  require('./assets/menu-line-horizontal.png'), width: opened ? menuSize*0.5 : menuSize*0.8, height: opened ? menuSize*0.5 : menuSize*0.8}}/>
                        </TouchableOpacity>

                        <Animated.View style={[styles.menuVertical, {
                            height: menuHeight,
                            width: width,
                        }]}>
                            <MenuItemsView menuItemStyle={menuItemStyle} isVisible={isVisible}/>
                        </Animated.View>
                    </View>
                )}
            </View>
        </View>
    );
}

export default HeaderView;